import {UyapRequest} from "./UyapRequest";
import {AdresRow} from "./CommonInterfaces";

export interface MtsIcraAcilisAlacakliTaraflarTalep {
    dosyaId: number | string
}

export interface MtsIcraAcilisAlacakliTaraflarCevap {
    taraflarList: Array<MtsIcraAcilisAlacakliTaraflarCevapRow>,
}


export interface MtsIcraAcilisAlacakliTaraflarCevapRow {
    ilgiliDosyaKisiId: string,
    asilTarafDosyaKisiId: string,
    ilgiliKisiTipi: string,
    ilgili: string,
    dosya: DosyaRow,
    ilgiliKisiIlkKisiKurumId: string,
    asilTarafIlkKisiKurumId: string,
    ilgiliKisiRolu: string,
    ilgiliKisiRolId: string,
    ilgilininHarcDurumu: string,
    sanikStatusu: string,
    addresList: Array<AdresRow>,
    secili: boolean,
    ilgiliKamuOzel: string,
    kisi: boolean,
    tcVatandasi: boolean,
    vergiNo: string,
    gulcelKisiKurumId: number,
    mersisNo: string
}

export interface ClientDosyaDVORow {
    dosyaID: string,
    dosyaBilgileriTurKodu: number,
    dosyaNotSayisi: number
}

export interface DosyaRow {
    clientDosyaDVO: ClientDosyaDVORow,
    dosyaTur: number
}


export class MtsIcraAcilisAlacakliTaraflar extends UyapRequest<MtsIcraAcilisAlacakliTaraflarTalep, MtsIcraAcilisAlacakliTaraflarCevap> {
    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    cache() {
        return {
            active: false,
            ttl: (60 * 24), //* 1 gun
            key: "_"
        };
    }

    getMockResponse(): any {
        return [{"ilgiliDosyaKisiId":"1234567891","asilTarafDosyaKisiId":"1234567891","ilgiliKisiTipi":"T","ilgili":"DENEME TEST HİZMETLERİ ANONİM ŞİRKETİ","dosya":{"clientDosyaDVO":{"dosyaID":"d2vxY1kVBNlAePecOTFuQDSabU1dOWqukhG7BEHqKsOrgw7p35YU1ED565c9WrCN","dosyaNotSayisi":0,"dosyaBilgileriTurKodu":0},"dosyaTur":-1},"ilgiliKisiIlkKisiKurumId":"20001234","asilTarafIlkKisiKurumId":"20001234","ilgiliKisiRolu":"ALACAKLI","ilgiliKisiRolId":"21","ilgilininHarcDurumu":"1","sanikStatusu":"H","addresList":[{"ilKodu":34,"ilAdi":"İSTANBUL","ilceAdi":"BEŞİKTAŞ","ilceKodu":8,"adres":"Deneme MAH. Test CAD.NO:0 BODRUM KAT ODA NO:0 BEŞİKTAŞ/İSTANBUL","kisiKurumID":20002415,"adresID":3664569999,"adresTuru":"ADRTR00002","eklenebilirAdresMi":false,"kayitliAdresMi":false,"aktifAdresmi":false,"guncellendiMi":false},{"ilKodu":34,"ilAdi":"İSTANBUL","ilceAdi":"BEŞİKTAŞ","ilceKodu":8,"adres":"Deneme MAH. Test CAD. Deneme GENEL MÜDÜRLÜĞÜ APT. NO:0","kisiKurumID":20001234,"adresID":367170000,"adresTuru":"ADRTR00001","eklenebilirAdresMi":false,"kayitliAdresMi":false,"aktifAdresmi":false,"guncellendiMi":false},{"ilKodu":34,"ilAdi":"İSTANBUL","ilceAdi":"BEŞİKTAŞ","ilceKodu":8,"adres":"Deneme MAH. Test CAD. Deneme G.MÜD.0 \r BEŞİKTAŞ/İSTANBUL","kisiKurumID":20002415,"adresID":367670001,"adresTuru":"ADRTR00002","eklenebilirAdresMi":false,"kayitliAdresMi":false,"aktifAdresmi":false,"guncellendiMi":false}],"secili":false,"ilgiliKamuOzel":"O","kisi":false,"tcVatandasi":false,"vergiNo":"1987654321","guncelKisiKurumId":20001234,"mersisNo":"0859038123456789"}];
    }

    getUrl(): string {
        return this.ImzaClientAddr + 'mts_icra_acilis_alacakli_taraflar_brd.ajx';
    }

    async parse(data: Array<any>): Promise<MtsIcraAcilisAlacakliTaraflarCevap> {
        return {taraflarList: data}
    }

}

export default MtsIcraAcilisAlacakliTaraflar;
